import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type CreateCreditCardBillPageParams, MatchPageTabs } from './types'
import { CreateCreditCardBillView } from '../feature-sets/CreateCreditCardBillView'

export const CreateCreditCardBillPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { id } = useParams<CreateCreditCardBillPageParams>()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.createCreditCardBillPageTitle)}
      breadcrumbs={[
        {
          link: url('CreditCardReconciliationPage'),
          name: intl.formatMessage(messages.creditCardReconciliationPageTitle),
        },
        // The {account name} crumb (linking to the account details page) comes
        // from the get-credit-card-account presenter companion hook, wired in task 2.4.
        {
          link: url('ReconciliationMatchPage', {
            id,
            tab: MatchPageTabs.UNMATCHED,
          }),
          name: intl.formatMessage(messages.reconciliationBreadcrumb),
        },
        {
          name: intl.formatMessage(messages.creditCardBillBreadcrumb),
        },
      ]}
    >
      <CreateCreditCardBillView accountId={Number(id)} />
    </Page>
  )
}
